// import Adminmasterlayout from "../../../layouts/Adminmasterlayout/Adminmasterlayout";
import AdmincmsNavbar from "../../../components/admin/AdmincmsNavbar/AdmincmsNavbar";
import AdmincmsHome from "./AdmincmsHome";
import "../../../assests/css/admin/AdmincmsManagement/AdmincmsManagement.css";
import Adminmasterlayout from "../../../layouts/Adminmasterlayout/Adminmasterlayout";

const AdmincmsManagement = () => {
  return (
      <Adminmasterlayout>
      <div className="cms-management">
        <AdmincmsNavbar />

        <div className="cms-content">
          <AdmincmsHome />
        </div>
      </div>
   </Adminmasterlayout>
  );
};

export default AdmincmsManagement;